import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const IconContainer = styled.button.attrs(props => ({
  className: props.e2eClass
}))`
  height: 1.125em;
  background: none;
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'inherit' : 'pointer')};
  align-items: center;
  justify-content: center;

  svg {
    path {
      fill: ${({ theme, disabled }) => (disabled ? theme.colors.grayLight : theme.colors.blue)};
    }
  }
`

export const StyledNumber = styled.span.attrs(props => ({
  className: props.e2eClass,
  value: props.value
}))`
  color: ${({ theme }) => theme.colors.blueDark};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 14px;
  padding: 0 14px;

  ${({ value, defaultValue }) =>
    value === defaultValue &&
    css`
      color: ${({ theme }) => theme.colors.accessibleGrey};
    `};
`
